const dateOnlyPattern = /^\d{4}-\d{2}-\d{2}$/;

export function salonDateOnly(value) {
  if (!value) return '';
  const text = String(value);
  if (dateOnlyPattern.test(text)) return text;
  return new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Asia/Taipei',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  }).format(new Date(value));
}
